export class UserManagementHubActions {
  readonly SAVE_USER: string = "SaveUser";
}

